module.exports = __webpack_public_path__ + "static/media/KOM_03.774e4dc1.png";